<template>
	<yxCategorySelect v-if="$isPlatOr(['Dy', 'Ks'])" v-bind="$attrs" v-on="$listeners" :platformId="platformId" />
	<yxCategorySelectSecond v-else v-bind="$attrs" v-on="$listeners" :platformId="platformId" />
</template>

<script>
import yxCategorySelect from './yxCategorySelect';
import yxCategorySelectSecond from './yxCategorySelectSecond';
export default {
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	components: {
		yxCategorySelect,
		yxCategorySelectSecond,
	},
};
</script>

<style>
</style>